import React from 'react';
import { medsCreateState, createMedsStep } from 'store/storeValtio';

export default function MedicationHourly({ prevStep, nextStep }) {

  function handleClick(hrs) {
    //console.log('handleClick', hrs);
    //const hr = hrs > 1 ? ' hours' : ' hour';
    //const often = `Every ${hrs}${hr}`;
    medsCreateState.often = 'hourly';
    medsCreateState.occurance = hrs;
    medsCreateState.schedule = [];
    nextStep(createMedsStep.confirm);
  }

  const hours = [];
  for (let i = 1; i < 13; ++i) {
    const hr = i > 1 ? ' hours' : ' hour';
    let cn = 'rawBtn w-full h-8 p-0 border-2 border-gray-400 text-sm text-blue';
    cn += (i === medsCreateState.occurance) ? " bg-green-300" : " bg-blue-300" ;
    hours.push(
      <li key={i} className={'snap-start scroll-m-0 p-0 m-0'}>
        <button
          onClick={()=>handleClick(i)}
          className={cn}
        >
          {i}{hr}
        </button>
      </li>
    );
  }

  return (
    <>
      <div className='medBody text-center'>
        How many hours are there between your doses?
      </div>
      <div className='mcard'>
        <div className='px-4 flex justify-center'>
          <ul className='w-96 h-[288px] snap-y snap-mandatory overflow-x-hidden overflow-y-scroll'>
              {hours}
          </ul>
        </div>
      </div>
    </>
  );
}
